import { get } from 'lodash';

import { ADDITIONAL_INFORMATION_SECTIONS_PATH } from './Sections/AdditionalInformationSections/constants';

const SUPPLEMENTARY_SECTION_REF = 'supplementary_info';
const INCIDENT_DETAILS_SECTION_REF = 'incident_details';

type ConfiguredFieldValue = { desc?: string; section?: string | null };
type SectionValue = { id?: string; desc?: string };

/**
 * Every FNOL configured field is stored flat in `incident_details.configured_fields`, whatever section the
 * admin sees it under -- the section is a `section` reference on the field. So the default, path-derived
 * label names the storage location and tells an admin who edited Supplementary Information that the error
 * is in Incident Details.
 *
 * This rewrites the label for those fields to the section the admin actually edited. Fields that really do
 * live in Incident Details return `undefined`, which leaves the default path alone.
 */
export const resolveFnolItemPath =
  (values: unknown) =>
  (item: unknown, index: number, path: string[]): string[] | undefined => {
    const field = item as ConfiguredFieldValue | undefined;
    const sectionRef = field?.section;
    if (!sectionRef || sectionRef === INCIDENT_DETAILS_SECTION_REF) return undefined;

    const name = field?.desc?.trim() || `[${index}]`;
    if (sectionRef === SUPPLEMENTARY_SECTION_REF) return [path[0], 'Supplementary Information', name];

    const sections = (get(values, ADDITIONAL_INFORMATION_SECTIONS_PATH) ?? []) as SectionValue[];
    const section = sections.find((candidate) => candidate?.id === sectionRef);
    return [path[0], section?.desc?.trim() || sectionRef, name];
  };
